import React, { useRef } from 'react'

// next components
import { useRouter } from 'next/router'

// third party components

// swiper
import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// components
import { HomePrevButton } from 'components/Button/HomePrevButton'
import { HomeNextButton } from 'components/Button/HomeNextButton'

// resource
import creatorList from 'assets/json/creator-merch/creator-merch.json'

// custom functions
import { useViewport } from 'utils'

// styles
import styles from './index.module.scss'
import CreatorMerchCard from 'components/Card/CreatorMerchCard'
import { useAuthentication } from 'hooks/useAuthentication'
import { useWalletModal } from '@solana/wallet-adapter-react-ui'
import { useWallet } from '@solana/wallet-adapter-react'
import { useDispatch } from 'react-redux'

const MerchCreatorSection = props => {
  const {} = props
  const viewport = useViewport()
  const router = useRouter()
  const swiperRef = useRef(null)
  const { profileInfo } = useAuthentication()
  const { setVisible } = useWalletModal()
  const { connected } = useWallet()
  const dispatch = useDispatch()

  const handleSeeAll = () => {
    if (connected && profileInfo?.username && profileInfo?.username.length > 0) {
      router.push(`/${profileInfo?.username.replaceAll(' ', '%20')}/merch/new`)
    } else {
      setVisible(true)
    }
  }

  const handleCardClick = item => {
    if (connected && profileInfo?.username && profileInfo?.username.length > 0) {
      dispatch({ type: 'set', merchProductId: item.id })
      router.push(`${profileInfo?.username.replaceAll(' ', '%20')}/merch/new`)
    } else {
      setVisible(true)
    }
  }

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev()
    }
  }

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext()
    }
  }

  return (
    <section className={styles.container}>
      <div className="w-full g-container justify-between lg:flex hidden">
        <div className={styles.headerContent}>
          <div className={styles.title}>create the merch you’ve always wanted</div>
          <p className={styles.description}>Premium blank collections. Delivered globally. No minimums.</p>
          <button className={styles.seeAllButton} onClick={handleSeeAll}>
            START DESIGNING &gt;&gt;
          </button>
        </div>
        <div className="flex items-end gap-5">
          <HomePrevButton onClick={() => handlePrev()} />

          <HomeNextButton onClick={() => handleNext()} />
        </div>
      </div>

      <div className="w-full g-container justify-between lg:hidden flex">
        <div className={styles.headerContent}>
          <div className={styles.title}>create the merch you’ve always wanted</div>
          <p className={styles.description}>Premium blank collections. Delivered globally. No minimums.</p>
        </div>
      </div>

      <div className={`w-full lg:block hidden mt-[45px] ${styles.swiperWrapper}`}>
        <Swiper
          navigation={viewport === 'lg' || viewport === 'xl' || viewport === '2xl'}
          slidesPerView={
            viewport === 'xs' ? 1.41 : viewport === 'sm' ? 2 : viewport === 'md' ? 4 : viewport === 'lg' ? 4.55 : 5.55
          }
          spaceBetween={viewport === 'xs' ? 20 : viewport === 'sm' ? 10 : 10}
          loop={true}
          className="heroMobileNavigationSwiper"
          initialSlide={7}
          onSwiper={swiper => {
            swiperRef.current = swiper
          }}
        >
          {creatorList.map((item, index) => (
            <SwiperSlide key={index}>
              <CreatorMerchCard data={item} onClick={item => handleCardClick(item)} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className={`w-full lg:hidden flex gap-[10px] overflow-x-auto mt-[25px] pl-[16px] ${styles.hideScrollbar}`}>
        {creatorList.map((item, index) => (
          <div key={index} className="max-w-[280px] min-w-[280px] h-[449px] overflow-hidden">
            <CreatorMerchCard data={item} onClick={item => handleCardClick(item)} />
          </div>
        ))}
      </div>

      <div className="w-full g-container flex lg:hidden justify-center mt-[25px] px-[20px]">
        <button className={styles.seeMore} onClick={handleSeeAll}>
          Start Designing
        </button>
      </div>
    </section>
  )
}

export default MerchCreatorSection
